import { z } from "zod";

/**
 * AfastamentoSchema
 */

export const AfastamentoSchema = z.object({
  idMotivoAfastamento: z.coerce.number(),
  dataInicio: z.coerce.date(),
  dataTermino: z.coerce.date(),
  observacao: z.string().default(""),
});

/**
 * AfastamentoForm
 */

export type AfastamentoForm = z.infer<typeof AfastamentoSchema>;